import React, { useCallback, useContext, useEffect, useState } from 'react'
import { Context } from '@/components/Context'
import { shortenAddress } from '@/utils/shortenAddress'

const deleteIndexedDBDatabases = (): void => {
    const dbsToDelete = ['walletconnect', 'WALLET_CONNECT_V2_INDEXED_DB']
    for (const dbName of dbsToDelete) {
        try {
            indexedDB.deleteDatabase(dbName)
            console.log(`Deleted IndexedDB: ${dbName}`)
        } catch (e) {
            console.warn(`Could not delete IndexedDB: ${dbName}`, e)
        }
    }
}

const NavigationConnection = () => {
    const { accountSignature, walletController, currentAccount } = useContext(Context)
    const { connectWallet, isConnected, disconnectWallet } = walletController()
    const [hasWalletConnectDb, setHasWalletConnectDb] = useState(false)

    useEffect(() => {
        const checkIndexedDB = async () => {
            if (!('indexedDB' in window)) return
            const dbs = await indexedDB.databases?.()
            const exists = dbs?.some((db) => db.name === 'WALLET_CONNECT_V2_INDEXED_DB')
            setHasWalletConnectDb(!!exists)
        }

        checkIndexedDB()
    }, [isConnected])

    const onConnect = useCallback(() => {
        disconnectWallet().then(() => {
            connectWallet()
        })
    }, [connectWallet])

    const onRefresh = useCallback(() => {
        deleteIndexedDBDatabases()
        window.location.reload()
    }, [])

    return (
        <span>
            {currentAccount && isConnected && accountSignature ? (
                <button type="button" className="nav__collection-button-unchecked" onClick={disconnectWallet}>
                    {shortenAddress(currentAccount)}
                </button>
            ) : (
                <button type="button" className="nav__connect" onClick={hasWalletConnectDb ? onRefresh : onConnect}>
                    {hasWalletConnectDb ? 'Refresh' : 'Connect'}
                </button>
            )}
        </span>
    )
}

export default NavigationConnection
